import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDummyRoomPlanConnection } from "./plan-connection/plan-connection";

import type { DummyRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	connection: DummyRoomCategoriesAndManagerStore["connection"];
};

export const QuestionDummyRoomConnection = ({ connection }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="プラン紐付け" categoryStore={connection}>
			<QuestionDummyRoomPlanConnection />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDummyRoomConnection.displayName = "QuestionDummyRoomConnection";
